import React from 'react';
import styled from 'styled-components';

import Bar from '../Search/Bar';
import Logo from './Logo';
import Navigation from './Navigation';

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-self: stretch;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1170px) {
    justify-content: space-around;
  }
`;

const Search = styled(Bar)`
  margin: 10px;
`;

function AppBar() {
  return (
    <Root>
      <Logo />
      <Search />
      <Navigation />
    </Root>
  );
}

export default AppBar;
